/**
 * Single source of truth for static lists shared across the UI.
 *
 * The backend exposes the canonical lists at GET /api/meta/options — most pages
 * fetch from there to honour POC-scoping. These exports are kept ONLY for screens
 * that need the unscoped admin view (e.g. the Call Logs filter on the admin POC
 * dropdown). Add new POCs in /app/backend/seed.py FIRST, then mirror here.
 */
export const POCS = ["Shankar", "Onkar", "Vaibhav", "Sasikiran", "Rajaneesh"];
export const TIERS = ["Premium", "Enterprise", "Standard"];
